<template>
  <section class="border border-stroke">
    <button
      type="button"
      class="flex w-full items-center justify-between border-b border-stroke bg-slate-50/50 px-4 py-3 text-left transition hover:bg-slate-50"
      @click="isOpen = !isOpen">
      <h5 class="text-base font-semibold text-slate-900">{{ title }}</h5>
      <svg
        class="h-5 w-5 shrink-0 text-slate-500 transition-transform"
        :class="{ 'rotate-180': isOpen }"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
    </button>
    <div v-show="isOpen" class="p-4">
      <slot />
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const props = withDefaults(
  defineProps<{
    title: string
    defaultOpen?: boolean
  }>(),
  { defaultOpen: false },
)

const isOpen = ref(props.defaultOpen)
</script>
